import React from "react"
import cx from "classnames"
import styles from "./styles.module.scss"

const BlockGrid = ({children}) => {
	return (
		<div className={cx(styles.Items)}>
			{children}
		</div>	
	)
}
export default BlockGrid